import { Component } from '@angular/core';

@Component({
  selector: 'app-datails-card',
  templateUrl: './datails-card.component.html',
  styleUrls: ['./datails-card.component.scss']
})
export class DatailsCardComponent {
  /**
   * container do card que contém detalhes nas telas de detalhes
   */
}
